// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (
  process.env.NEXT_PUBLIC_TRACK_ERRORS &&
  window.location.origin === process.env.DASHBOARD_URL
) {
  console.log('Initializing errors client', SENTRY_DSN);
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      'https://8f6dbb39cafd4ae28564ddb1dccb6b54@o1261767.ingest.sentry.io/6440029',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.001,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
}
